
import React, { useEffect, useState } from 'react';
import { LazyQueue } from 'scripts/components/lazy/lazyLoadComponent';

type Props = React.PropsWithChildren<{
    delayMs?: number;
    lazyPriority?: number;
    placeholder?: React.ReactNode | null;
}>;

export const DelayedComponent = ({ children, delayMs, lazyPriority, placeholder }: Props) => {
    const [isShown, setIsShown] = useState<boolean>(false);

    useEffect(() => {
        setIsShown(false);

        if (lazyPriority != null) {
            const cancel = LazyQueue.enqueue(async () => {
                setIsShown(true);
            }, lazyPriority);

            return cancel;
        }

        if (delayMs != null) {
            const timer = setTimeout(() => {
                setIsShown(true);
            }, delayMs);

            return () => clearTimeout(timer);
        }


        setIsShown(true);
    }, [delayMs, lazyPriority]);

    return (
        <>
            {isShown ? children : placeholder}
        </>
    );
};

export default DelayedComponent;
